import type { CalendarPresentationState } from "../features/calendar/presentation-controller.ts";
import type { TaskCollectionPresentationState } from "../features/tasks/task-collection-presentation-controller.ts";

type CalendarDynamicState = Omit<CalendarPresentationState, "timezone" | "today" | "formatDate" | "editable" | "icon">;
type TaskCollectionDynamicState = Omit<TaskCollectionPresentationState, "today" | "editable" | "memberEmail" | "categoryName" | "spaceName" | "formatDate" | "formatTimestamp" | "recurrenceLabel" | "icon">;

export interface PresentationStateCapabilities {
  calendar: () => CalendarDynamicState;
  taskCollection: () => TaskCollectionDynamicState;
  timezone: () => string;
  today: () => string;
  editable: (taskId?: string) => boolean;
  memberEmail: (id: string) => string;
  categoryName: (id: string) => string;
  spaceName: (rootId: string) => string;
  formatDate: (value: string) => string;
  formatTimestamp: (value: string) => string;
  recurrenceLabel: TaskCollectionPresentationState["recurrenceLabel"];
  icon: (name: string) => string;
}

export function createPresentationStateController(capabilities: PresentationStateCapabilities) {
  return {
    calendar(): CalendarPresentationState {
      return { ...capabilities.calendar(), timezone: capabilities.timezone(), today: capabilities.today(), formatDate: capabilities.formatDate, editable: taskId => capabilities.editable(taskId), icon: capabilities.icon };
    },
    taskCollection(): TaskCollectionPresentationState {
      return { ...capabilities.taskCollection(), today: capabilities.today(), editable: capabilities.editable, memberEmail: capabilities.memberEmail, categoryName: capabilities.categoryName, spaceName: capabilities.spaceName, formatDate: capabilities.formatDate, formatTimestamp: capabilities.formatTimestamp, recurrenceLabel: capabilities.recurrenceLabel, icon: capabilities.icon };
    },
  };
}
